import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      id: null,
      username: '',
      name: '',
      roleId: null,
      roleName: '',
      permissions: []
    },
    menuList: [],
    token: '',
    cachedComponentNames: []
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_MENU_LIST(state, menuList) {
      state.menuList = menuList
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    LOGOUT(state) {
      state.user = {
        id: null,
        username: '',
        name: '',
        roleId: null,
        roleName: '',
        permissions: []
      }
      state.menuList = []
      state.token = ''
      state.cachedComponentNames = []
      localStorage.removeItem('user')
      localStorage.removeItem('token')
    },
    ADD_CACHED_VIEW(state, name) {
      if (name && !state.cachedComponentNames.includes(name)) {
        state.cachedComponentNames.push(name)
      }
    },
    DEL_CACHED_VIEW(state, name) {
      const index = state.cachedComponentNames.indexOf(name)
      if (index > -1) {
        state.cachedComponentNames.splice(index, 1)
      }
    },
    CLEAR_CACHED_VIEWS(state) {
      state.cachedComponentNames = []
    }
  },
  actions: {
    setUser({ commit }, user) {
      commit('SET_USER', user)
      localStorage.setItem('user', JSON.stringify(user))
    },
    setMenuList({ commit }, menuList) {
      commit('SET_MENU_LIST', menuList)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
      localStorage.setItem('token', token)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    initUser({ commit }) {
      const user = localStorage.getItem('user')
      const token = localStorage.getItem('token')
      if (user) {
        commit('SET_USER', JSON.parse(user))
      }
      if (token) {
        commit('SET_TOKEN', token)
      }
    }
  },
  getters: {
    user: state => state.user,
    menuList: state => state.menuList,
    token: state => state.token,
    cachedComponentNames: state => state.cachedComponentNames,
    hasPermission: state => permission => {
      return state.user.permissions.includes(permission)
    }
  }
})